import useSwr from "../useGet.hook.js";
/**
 * SWR hook useGetSDBProductTourUserDataQueryHook
 */
export const useGetSDBProductTourUserDataQueryHook = ({ id, application, tenant }, axiosConfig, swrConfig) => useSwr({
    url: `/user/tourdata`,
    method: "get",
    params: { id, application, tenant },
    ...axiosConfig,
}, swrConfig);
export default useGetSDBProductTourUserDataQueryHook;
